import React, { useEffect, useState } from "react";
import { supabase } from "../supabase";

export default function Products() {
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [categories, setCategories] = useState<any[]>([]);

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, []);

  const fetchProducts = async () => {
    setLoading(true);
    const { data } = await supabase
      .from("products")
      .select("*, categories(name)")
      .order("name");
    if (data) setProducts(data);
    setLoading(false);
  };

  const fetchCategories = async () => {
    const { data } = await supabase
      .from("categories")
      .select("*")
      .order("name");
    if (data) setCategories(data);
  };

  const updateCategory = async (id: number, categoryId: number) => {
    await supabase
      .from("products")
      .update({ category_id: categoryId })
      .eq("id", id);
    fetchProducts();
  };

  const updateName = async (id: number, currentName: string) => {
    const newName = window.prompt("Новое название RU:", currentName);
    if (!newName || newName === currentName) return;
    await supabase.from("products").update({ name: newName }).eq("id", id);
    fetchProducts();
  };

  const updateNameEn = async (id: number, currentName: string) => {
    const newName = window.prompt("Новое название EN:", currentName || "");
    if (newName === null) return;
    await supabase.from("products").update({ name_en: newName }).eq("id", id);
    fetchProducts();
  };

  const deleteProduct = async (id: number) => {
    if (!window.confirm("Удалить продукт?")) return;
    await supabase.from("products").delete().eq("id", id);
    fetchProducts();
  };

  const filtered = products.filter(
    (p) =>
      p.name?.toLowerCase().includes(search.toLowerCase()) ||
      p.name_en?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div>
      <div style={s.header}>
        <h1 style={s.title}>🥕 Продукты ({products.length})</h1>
      </div>
      <input
        style={{ ...s.search, marginBottom: 16 }}
        placeholder="Поиск продукта (RU или EN)..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
      {loading ? (
        <p>Загрузка...</p>
      ) : (
        <table style={s.table}>
          <thead>
            <tr style={s.thead}>
              <th style={s.th}>ID</th>
              <th style={s.th}>Название RU</th>
              <th style={s.th}>Название EN</th>
              <th style={s.th}>Категория</th>
              <th style={s.th}>Ед.</th>
              <th style={s.th}>Действия</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((p) => (
              <tr key={p.id} style={s.tr}>
                <td style={s.td}>{p.id}</td>
                <td style={s.td}>{p.name}</td>
                <td style={s.td}>
                  <span style={{ color: p.name_en ? "#222" : "#e74c3c" }}>
                    {p.name_en || "—"}
                  </span>
                </td>
                <td style={s.td}>
                  <select
                    style={s.selectSmall}
                    value={p.category_id || ""}
                    onChange={(e) =>
                      updateCategory(p.id, parseInt(e.target.value))
                    }
                  >
                    {categories.map((c) => (
                      <option key={c.id} value={c.id}>
                        {c.name}
                      </option>
                    ))}
                  </select>
                </td>
                <td style={s.td}>{p.unit}</td>
                <td style={s.td}>
                  <button
                    style={s.btnSmall}
                    onClick={() => updateName(p.id, p.name)}
                  >
                    ✏️ RU
                  </button>
                  <button
                    style={{ ...s.btnSmall, backgroundColor: "#9b59b6" }}
                    onClick={() => updateNameEn(p.id, p.name_en)}
                  >
                    ✏️ EN
                  </button>
                  <button
                    style={{ ...s.btnSmall, backgroundColor: "#e74c3c" }}
                    onClick={() => deleteProduct(p.id)}
                  >
                    Удалить
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 24,
  },
  title: { fontSize: 24, fontWeight: 700, color: "#222", margin: 0 },
  search: {
    padding: "10px 14px",
    borderRadius: 8,
    border: "1px solid #eee",
    fontSize: 14,
    width: 300,
    outline: "none",
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: "#fff",
    borderRadius: 12,
    overflow: "hidden",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  },
  thead: { backgroundColor: "#f9f9f9" },
  th: {
    padding: "12px 16px",
    textAlign: "left",
    fontSize: 13,
    color: "#888",
    fontWeight: 600,
  },
  tr: { borderBottom: "1px solid #f0f0f0" },
  td: { padding: "12px 16px", fontSize: 14, color: "#222" },
  selectSmall: {
    padding: "4px 8px",
    borderRadius: 6,
    border: "1px solid #eee",
    fontSize: 13,
    outline: "none",
  },
  btnSmall: {
    padding: "6px 10px",
    backgroundColor: "#2ECC71",
    color: "#fff",
    border: "none",
    borderRadius: 6,
    fontSize: 12,
    cursor: "pointer",
    marginRight: 4,
  },
};
